import styled from 'styled-components'
import { MdClose } from 'react-icons/md'

export const CloseWithdrawModalBtn = styled(MdClose)`
  cursor: pointer;
  position: absolute;
  top: 10px;
  right: 20px;
  width: 52px;
  height: 52px;
  padding: 0;
  z-index: 10;
  border-radius: 50px;
`

export const WithdrawWrapper = styled.div`
  width: 440px;
  padding: 30px 30px;
`

export const WithdrawModalContainer = styled.div`
  @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
    width: 100%;
    height: 70%;
  }
`

export const WithdrawModalBackground = styled.div`
  width: auto;
  background: ${({ theme }) => theme.colors.white};
  z-index: 90;
  height: 100%;
  position: fixed;
  top: 0;
  right: 0;
  overflow-y: scroll;

  @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
    width: 100%;
    top: 100px;
    border-radius: 40px 40px 0px 0px;
  }
`

export const WithdrawComponent = styled.div`
  margin-top: 3rem;
`
